// extracted by mini-css-extract-plugin
export default {"reservation_item__details":"user-details_reservation_item__details__vRC9H"};